<template>
  <div>
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid justify-content-between">
          <div class="col">
            <div class="">
              <div class="text-3xl font-bold">What's New?</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-12 sm:col-12 comp-grid">
            <Fieldset class="mb-2" legend="1.0.5">
              <div class="font-bold">
                <ul>
                  <li>
                    Filter dashboard report based on a given time period
                  </li>
                </ul>
              </div>
            </Fieldset>
            <Fieldset class="mb-2" legend="1.0.4">
              <div class="font-bold">
                <ul>
                  <li>
                    Bug fixes and performance improvements
                  </li>
                </ul>
              </div>
            </Fieldset>
            <Fieldset class="mb-2" legend="1.0.3">
              <div class="font-bold">
                <ul>
                  <li>
                    Front Office Only.
                    <span class="font-light"
                      >New page added 🎉. The Announcements page will allow agents to send out
                      messages (announcements, service updates, news, greetings, tips and
                      more) to customers. Customers will receive push
                      notifications and Sms everytime messages are sent
                      out.</span
                    >
                  </li>
                </ul>
              </div>
            </Fieldset>
            <Fieldset class="mb-2" legend="1.0.2">
              <div class="font-bold">
                <ul>
                  <li>
                    Fixed issue of inbound calls over-writing uncompleted
                    tickets.
                    <span class="font-light"
                      >The platform is able to detect status of ticket
                      submissions. If a call ends whiles ticket is not
                      submitted, the system temporarily (5-minutes) blocks
                      inbound calls until ticket is submitted. This gives the
                      agent 5-minutes to finish up complaint ticket before
                      another inbound call</span
                    >
                  </li>
                  <li>Added Winneba and Dwomo to list of districts</li>
                  <li>Bugs fixes and platform performance improvements</li>
                </ul>
              </div>
            </Fieldset>
            <Fieldset class="mb-2" legend="1.0.1">
              <div class="font-bold">
                <ul>
                  <li>Added List of Regions and Districts</li>
                  <li>Bugs fixes and platform performance improvements</li>
                </ul>
              </div>
            </Fieldset>
            <Fieldset class="mb-2" legend="1.0.0">
              <div class="font-bold">
                <ul>
                  <li>Initial Release</li>
                </ul>
              </div>
            </Fieldset>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, onMounted, toRefs, onBeforeUnmount } from "vue";
import { useApp } from "@/composables/app.js";
const props = defineProps({
  src: {
    type: String,
  },
});
const app = useApp();
</script>
